import {requestAnimationFrame} from 'CommonUtils/raf.js';

import {isMob, chatBubble_display} from './assistant';

const btn = document.createElement('div');
btn.id = 'ai-fixed-btn';
btn.className = 'assistant-btn aiChatToggle'; // Optional: add a class


function createDeskChatBubble(){
    const chat_bubble = document.createElement('div');
    chat_bubble.id = 'ai-chat-bubble';
    chat_bubble.innerHTML = "<div id='ai-chat-bubble-close'><svg id='ai-svg1' width='12' height='12' xmlns='http://www.w3.org/2000/svg'><line x1='1' y1='1' x2='11' y2='11' stroke='#828282' stroke-width='1'/><line x1='11' y1='1' x2='1' y2='11' stroke='#828282' stroke-width='1'/></svg></div><p>Hey there!<span>👋</span><br>I'm iFOREX AI, your personal trading knowledge assistant. How can I assist you today?</p><svg id='ai-svg2' width='12' height='12' xmlns='http://www.w3.org/2000/svg'><line x1='6' y1='0' x2='12' y2='12' stroke='black' stroke-width='1'/><line x1='6' y1='0' x2='0' y2='12' stroke='black' stroke-width='1'/><polygon points='6,0 12,12 0,12' fill='white' stroke='none'/></svg>";

    return chat_bubble;
}



export function loadBtn(elem){
    elem.appendChild(btn);
    if(chatBubble_display){
        elem.appendChild(createDeskChatBubble());
        btn .innerHTML = '<span id="ai-count">1</span>';
    }
}

